import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/contractor";




class ContractorService {

  editcontractor(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addcontractor(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }

  getExternalData(nip:string){
      return axios
        .post(API_URL + '/external-data', nip)
        .then(response => {
          return response.data;
      });
  }
  contractorExist(name:string, shortname:string, nip:string, id : number){
    return axios
      .post(API_URL + '/exist', {name:name, shortname:shortname, nip: nip, id : id})
      .then(response => {
        return response.data;
      });
  }

  similarityList(name:string){
    return axios
      .post(API_URL + '/similarity-list', {name:name})
      .then(response => {
        return response.data;
      });
  }

  deletecontractor(contractorId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+contractorId)
      .then(response => {
        return response.data;
      });
  }

  massEdit(contractorIds:number[], formValues:any) {
    //console.log(contractorIds)
    //console.log(formValues)
    //console.log( {contractorIds : contractorIds, data:formValues})
    var data = {contractorIds : contractorIds, data:formValues}
    return axios
      .post(API_URL + '/mass-edit', data)
      .then(response => {
        return response.data;
      });
  }
  
  getcontractorlookups() {
    return axios
      .get(API_URL + "/contractors-lookups" , {
        params:{
           
        }
      })
      .then(response => {
        return response;
      });
  }


  getcontractors(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  
  getarchives(query:string) {
    return axios
      .get(API_URL + "/archives?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


  getContractorDataByID(contractorId:number, query:string) {
    
    return axios
      .get(API_URL + "/card/" + contractorId + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getNextContractorDataByID(contractorId:number, query:string) {
    
    return axios
      .get(API_URL + "/nextcard/" + contractorId + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getPrevContractorDataByID(contractorId:number, query:string) {
    
    return axios
      .get(API_URL + "/prevcard/" + contractorId + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }

  getOwnContractorGroups(){
    return axios
    .get(API_URL + "/own-contractor-groups" , {
      params:{
         
      }
    })
    .then(response => {
      return response.data;
    });

  }


  getaddresses(id_list:string){
    return axios
      .post(API_URL + '/getaddresses', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }

  getmails(id_list:string){
    return axios
      .post(API_URL + '/getmails', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }

  setCorrAddresses(id_list:string){
    return axios
      .post(API_URL + '/setCorrAddresses', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }

  toArchival(id_list:string){
    return axios
      .post(API_URL + '/toArchival', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }

  restoreArchival(id_list:string){
    return axios
      .post(API_URL + '/restoreArchival', {id_list:id_list})
      .then(response => {
        return response.data;
      });
  }


  

 

}

export default new ContractorService();